import { Box } from '@mui/material';
import { Card } from '@mui/material';
// import { CardActions } from '@mui/material';
import { CardContent } from '@mui/material';
// import { Button } from '@mui/material';
import Typography from '../../typography/typography';

export interface IGridCard {
	name: string;
	company: string;
	status: string;
	email: string;
	amount: string;
}

export const GridCardMarkup = (props: any) => {
	return (
		<Card
			sx={{
				width: '16.625rem',
				borderRadius: '0.5rem',
				border: '0.5px solid theme.secondary.200, #F5F6F5',
				backgroundColor: 'theme.secondary.100',
				boxShadow: `
                0px 0px 2px 0px #E0E0E0, 
                0px 1px 4px - 2px rgba(24, 39, 75, 0.02), 
                0px 4px 4px - 2px rgba(24, 39, 75, 0.06)`,
				m: 3
			}}>
			<CardContent
				sx={{
					display: 'flex',
					flexDirection: 'column',
					padding: '1rem 1rem 1.25rem 1rem',
					justifyContent: 'space-between',
					alignItems: 'flex-start',
					flexShrink: 0
				}}>
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						justifyContent: 'space-between',
						marginBottom: 1
					}}>
					<Box>
						<Typography type='s3' weight='medium'>
							{props.data.name || 'Kristin Watson'}
						</Typography>
						<Typography type='s3' color='theme.secondary.800'>
							{props.data.company || 'Barone LLC.'}
						</Typography>
					</Box>
					<Box>
						<Typography
							type='s4'
							sx={{
								padding: '0.25rem 0.375rem',
								gap: '0.5rem',
								borderRadius: '0.5rem',
								backgroundColor: 'theme.secondary.200'
							}}
							color='theme.secondary.900'>
							{props.data.status || 'Lost'}
						</Typography>
					</Box>
				</Box>
				<Typography
					type='s3'
					sx={{
						overflow: 'hidden',
						color: 'theme.secondary.900',
						textDecorationLine: 'underline'
					}}>
					{props.data.email || 'kristen.watson@example.com'}
				</Typography>
				<Box sx={{ mt: '1.25rem', display: 'flex', alignItems: 'center' }}>
					<Typography
						type='s3'
						sx={{ mr: '.2rem' }}
						color='theme.secondary.900'>
						{props.data.amount || '$10,000,000'}
					</Typography>
					<Typography type='s4' color='theme.secondary.800'>
						est value
					</Typography>
				</Box>
			</CardContent>
			{/* <CardActions>
                <Button size="small">Learn More</Button>
            </CardActions> */}
		</Card>
	);
};

export const GridCard = (props: any) => {
	return (
		<>
			{props.data.map((cardData: IGridCard) => {
				return <GridCardMarkup data={cardData} />;
			})}
		</>
	);
};

export default GridCard;
